.TextInput, 
.TextInput:focus{
    width: 150px;
    background-color: white !important;
    transition: opacity 0.15s;
}